module.exports = __webpack_public_path__ + "img/avto-shinauri.cf5c5c9d.png";